module.exports = __webpack_public_path__ + "static/media/emj16.c21a95ca.svg";